import styled from 'styled-components';
import { Form as FormAtom } from 'components/atoms/form';
import { InputNumber } from 'components/atoms/input';
import { Radio as RadioAtom } from 'components/atoms/radio';
import { Caption01 } from 'components/styles';

export const FormItem = styled(FormAtom.Item)`
  .ant-form-item-label > label {
    gap: var(--spacing-02);
  }
  && {
    padding-bottom: 0px;
    margin-bottom: 0px;
  }
`;
export const ManualBudgetedHoursFormItem = styled(FormItem)`
  .ant-form-item-label {
    visibility: hidden;
    height: 0px;
  }
  .ant-form-item-control {
    padding-left: var(--spacing-06);
    .ant-form-item-control-input {
      min-height: 0px;
    }
  }
`;
export const BudgetHoursInputWrapper = styled.div<{ hide: boolean }>`
  ${InputNumber} {
    display: ${({ hide }) => (hide ? 'none' : 'block')};
  }
`;
export const Hint = styled.span`
  ${Caption01};
  color: var(--gray-80);
`;
export const AutomaticLabelWrapper = styled.span`
  display: inline-flex;
  flex-direction: column;
`;
export const FooterWrapper = styled.div`
  display: flex;
  div:first-child {
    flex: 1;
    text-align: left;
  }
`;

export const Radio = styled(RadioAtom)`
  display: flex;
  align-items: flex-start;
  .ant-radio {
    top: 2px;
  }
  ${Hint} {
    display: none;
  }
  &&.ant-radio-wrapper-checked {
    ${Hint} {
      display: block;
    }
  }
`;
export const Form = styled(FormAtom)`
  min-height: 132px;
`;
